export default "__VITE_ASSET__88476fba__"